import { useEffect } from 'react';

function useAutoFocus(ref, focusOnMount) {
  useEffect(() => {
    if (ref && ref.current && focusOnMount) {
      ref.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusOnMount]);
}

export default useAutoFocus;
